module.exports = __webpack_public_path__ + "img/scene-clock.8b626908.png";